export default {
    manage_deleteCustomer_title: "Delete Customer",
    manage_deleteCustomers_title: "Delete Customers",
    manage_deleteCustomers_description: "Are you sure you want to delete the Customers?",
    manage_deleteCustomer_description: "Are you sure you want to delete this Customer?",
    manage_deleteCustomer_successMessage: "Customer deleted",
    manage_deleteCustomers_successMessage: "Customers deleted",
    manage_deleteCustomers_are_in_use: "It is not possible to delete customers in use",
}